<template>
    <div class="p-10">
        <template v-if="!waitingStart">
            <div>Rejoindre une partie</div>
            <div class="mt-4">
                <input v-model="partieToken" type="tel" placeholder="ID de la partie" class="border p-2 rounded w-full" />
            </div>
            <div class="mt-6">
                <button @click="joinPartie" class="bg-green-500 text-white px-4 py-2 rounded w-full">
                    Rejoindre la partie
                </button>
            </div>
        </template>
        <template v-if="waitingStart">
            <div class="flex h-screen flex-col justify-center items-center text-center">
                <i class="fas fa-spinner fa-spin fa-2x mb-4"></i>
                <div class="text-gray-600">Veuillez patienter le temps que l'hôte démarre la partie.</div>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    data() {
        return {
            partieToken: null,

            waitingStart: false,
            partie: null,
        }
    },
    methods: {
        async joinPartie() {
            if (!this.partieToken) {
                this.$toast.error('Veuillez entrer un token de partie.');
                return;
            }
            let response = await this.$request.post('/join-partie', {
                token: localStorage.getItem('user-token'),
                partie_token: this.partieToken
            })
            if (response) {
                this.partie = response
                this.waitingStart = true

                this.$websocket.receive("start-partie-" + this.partie.token, data => {
                    this.$router.push({ name: 'Game', params: { partieToken: this.partie.token } });
                });
            } else {
                this.$toast.error('Erreur lors de la connexion à la partie.');
            }
        }
    },
}
</script>

<style lang="scss" scoped>

</style>